module.exports = __webpack_public_path__ + "static/media/desktoplogoWhite.06576a42.png";